import { createAsyncThunk } from '@reduxjs/toolkit';
import { BundleCake } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindBundleCake, GetBundleCake } from '../../bundleCake/api/interface';

export const findSelectBundleCake = createAsyncThunk(
  'selectBundleCake/findSelectBundleCake',
  async (values: FindBundleCake, { rejectWithValue }) => {
    try {
      const response = await BundleCake.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectBundleCake = createAsyncThunk(
  'selectBundleCake/searchSelectBundleCake',
  async (values: FindBundleCake, { rejectWithValue }) => {
    try {
      const response = await BundleCake.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getSelectBundleCake = createAsyncThunk(
  'selectBundleCake/getSelectBundleCake',
  async ({ id }: GetBundleCake, { rejectWithValue }) => {
    try {
      const response = await BundleCake.get(id);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
